export enum AccountType {
  MAIN = 0,
  VAULT = 1,
  DAPP = 2
}

export enum KeySpace {
  RECEIVE = 0,
  CHANGE = 1
}

export enum SessionRequestType {
  SignMessage = 'signMessage',
  AddToken = 'addToken',
  SignTransaction = 'signTransaction',
  SendTransaction = 'sendTransaction',
}
